<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pv"></a>Contents</h1>
<p class="tocf"><a class="xref" href="#/chishindell0007#intro"><span class="sm">INTRODUCTION</span>   The Making and Remaking of an American Chemist</a></p>
<p class="toc"><a class="xref" href="#/chishindell0008#ch01"><span class="sm">ONE</span>   From Farm Boy to Wartime Chemist</a></p>
<p class="toc"><a class="xref" href="#/chishindell0009#ch02"><span class="sm">TWO</span>   From Industrial Chemistry to Copenhagen</a></p>
<p class="toc"><a class="xref" href="#/chishindell0010#ch03"><span class="sm">THREE</span>   From Novice in Europe to Expert in America</a></p>
<p class="toc"><a class="xref" href="#/chishindell0011#ch04"><span class="sm">FOUR</span>   From Nobel Laureate to Manhattan Project Burnout</a></p>
<p class="toc"><a class="xref" href="#/chishindell0012#ch05"><span class="sm">FIVE</span>   A Separation Man No More</a></p>
<p class="toc"><a class="xref" href="#/chishindell0013#ch06"><span class="sm">SIX</span>   A Return to Science</a></p>
<p class="toc"><a class="xref" href="#/chishindell0014#ch07"><span class="sm">SEVEN</span>   To Hell with the Moon!</a></p>
<p class="toc"><a class="xref" href="#/chishindell0015#epil"><span class="sm">EPILOGUE</span>   A Life in Science</a></p>
<p class="tocbmf"><a class="xref" href="#/chishindell0016#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chishindell0017#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chishindell0018#archives">List of Archives</a></p>
<p class="tocbm"><a class="xref" href="#/chishindell0019#list">List of Oral History Interviews</a></p>
<p class="tocbm"><a class="xref" href="#/chishindell0020#biblio">Bibliography</a></p>
<p class="tocbm"><a class="xref" href="#/chishindell0021#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-shindell-0006.vue?4afd6e34